/*
 * Julvärmen home: behaviour for the home sections that jv-theme.js does not already cover.
 * Loaded (deferred) by sections/jv-newsletter.liquid.
 *
 * <jv-newsletter data-form-id="…"> wraps the Adventsbrevet signup. After any customer form is sent (this one, the
 * popup, a footer form), Shopify renders every customer form on the next page with the same "posted" or error state.
 * This element keeps its thank-you message or error only when its own form was the one sent, and otherwise shows
 * the normal empty form again. Which form was sent is remembered for one page load in sessionStorage.
 */
(() => {
  'use strict';

  if (customElements.get('jv-newsletter')) return;

  const KEY = 'jv-newsletter-submitted';
  const store = {
    get() {
      try {
        return window.sessionStorage.getItem(KEY) || '';
      } catch (error) {
        return '';
      }
    },
    set(value) {
      try {
        window.sessionStorage.setItem(KEY, value);
      } catch (error) {
        /* storage blocked: the hash check below still works */
      }
    },
    clear() {
      try {
        window.sessionStorage.removeItem(KEY);
      } catch (error) {
        /* nothing to clear */
      }
    },
  };

  // Read once per page load: the page right after a submit is the one that shows its result.
  const submittedId = store.get();
  store.clear();

  class JvNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      const formId = this.dataset.formId || this.form.id;

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.form.addEventListener('submit', () => store.set(formId), { signal: this.controller.signal });

      if (this.checked) return;
      this.checked = true;

      const success = this.querySelector('[data-jv-newsletter-success]');
      const error = this.querySelector('[data-jv-newsletter-error]');
      if (!success && !error) return;

      const input = this.querySelector('input[type="email"]');
      const mine = submittedId === formId || window.location.hash === `#${formId}`;
      if (mine) {
        if (success) success.focus({ preventScroll: true });
        else if (input) input.focus({ preventScroll: true });
        return;
      }

      if (success) success.remove();
      if (error) error.remove();
      const fields = this.querySelector('[data-jv-newsletter-fields]');
      if (fields) fields.hidden = false;
      if (input) {
        input.value = '';
        input.removeAttribute('aria-invalid');
        const fine = this.querySelector('.jv-nl__fine[id]');
        if (fine) input.setAttribute('aria-describedby', fine.id);
        else input.removeAttribute('aria-describedby');
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }
  }

  customElements.define('jv-newsletter', JvNewsletter);
})();
